<script>
import { BBadge, BFormTextarea } from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";
import HamletTable from "@core/components/common/HamletTable.vue";

export default {
    name: 'Changes',
    components: {HamletTable, Button, BBadge, BFormTextarea},
    props: {
        label: {
            default() {
                return this.$t('Component(ChangeLog):changes-label')
            }
        },
        changes: {
            required: true,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                    title: this.$t('Component(Grid):column-title'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'type',
                    label: this.$t('Component(Grid):column-type'),
                    title: this.$t('Component(Grid):column-type'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'oldValue',
                    label: this.$t('Component(Grid):column-old-value'),
                    title: this.$t('Component(Grid):column-old-value'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'newValue',
                    label: this.$t('Component(Grid):column-new-value'),
                    title: this.$t('Component(Grid):column-new-value'),
                    order: 1,
                    active: true,
                },
            ]
        };
    },
    methods: {
        fetch(config, callback) {
            const start = config.page * config.perPage - config.perPage;
            let end = start + config.perPage;
            if (end > this.changes.length) {
                end = undefined;
            }
            callback(this.changes.length, this.changes.slice(start, end));
        },
        show() {
            this.$refs['changes-modal'].show();
        }
    }
}
</script>

<template>
    <HamletTable
        card-class="mb-0 pb-0"
        :columns="columns"
        :fetch="fetch"
    >
        <template #header-label>{{ label }}</template>

        <template #cell-title="data">
            {{ data.item.subject }}
        </template>

        <template #cell-oldValue="data">
            <div v-if="data.item.oldValue">
                <div v-if="data.item.oldValue.length < 50">{{ data.item.oldValue }}</div>
                <b-form-textarea
                    v-else
                    readonly
                    rows="3"
                    :value="data.item.oldValue"
                />
            </div>
        </template>

        <template #cell-newValue="data">
            <div v-if="data.item.newValue">
                <div v-if="data.item.newValue.length < 50">{{ data.item.newValue }}</div>
                <b-form-textarea
                    v-else
                    readonly
                    rows="3"
                    :value="data.item.newValue"
                />
            </div>
        </template>

        <template #cell-type="data">
            <b-badge>{{ data.item.type }}</b-badge>
        </template>
    </HamletTable>
</template>
